import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderWug extends ResourceItemHtmlProvider {
    constructor(filterService) {
        super(filterService);
        this.cssClasses = {
            col: 'col-4 -xl-half -mb3 -m-mb3',
            resource: 'Res-wrp',
            resorceImageRatio: 'Embed Embed--16by9 -bg-black',
            resorceImage: 'Section-bg',
            resourceContent: 'Res-content',
            resourceType: 'Res-label',
            webinarStartDate: 'Res-date',
            resourceSummary: 'Res-summary',
            resourceCTA: 'Res-cta',
        }

        this.monthNamesMap = new Map();
        this.monthNamesMap.set("en", ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "Decembеr"]);
        this.monthNamesMap.set("de", ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]);
        this.monthNamesMap.set("fr", ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]);
        this.monthNamesMap.set("ja", ["1月", "2月", "三月", "4月", "五月", "六月", "7月", "8月", "9月", "10月", "11月", "12月"]);
        this.monthNamesMap.set("pt", ["Janeiro", "Fevereiro", "Marcha", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]);
        this.monthNamesMap.set("es", ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]);
        this.monthNamesMap.set("zh-TW", ["一月", "二月", "遊行", "四月", "可能", "六月", "七月", "八月", "九月", "十月", "十一月", "十月"]);
        this.monthNamesMap.set("nl", ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "Decembre"]);
        this.monthNamesMap.set("sv", ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"]);
    }

    getItemHtml(item, relatedMedia) {
        const { col, resource, resorceImageRatio, resorceImage, resourceType, webinarStartDate, resourceSummary, resourceCTA, resourceContent } = this.cssClasses;
        const { imageData } = super.setRelatedMedia(item, relatedMedia);
        const { Title, CTAText, UrlName: resourcePath, Summary, StartDate, ExternalUrl, CTAUrl } = item;
        const imageFallback = 'https://d34smkdb128qfi.cloudfront.net/images/librariesprovider2/default-album/resources/resource-default-thumbnail.jpg';
        const contentType = item.resourceCategory[0];
        const pageUrl = super.getResourceUrl(item.contenttypes[0]);
        const featuredLabel = Boolean(Number(item.IsFeatured)) ? '<div><span class="-c-black -fs12 -ml0 -fw5 Res-date" style="background-color:#ffe600">Featured</span></div>' : '';
        let resourceUrl;

        if (CTAUrl) {
            resourceUrl = CTAUrl;
        } else if (ExternalUrl) {
            resourceUrl = ExternalUrl;
        }
        else {
            resourceUrl = `${pageUrl}/${resourcePath}`;
        }

        let html = `
        <div class="${col}">
            <a href="${resourceUrl}" class="${resource}">
                <div class="${resorceImageRatio}">
                    <div class="${resorceImage}">
                        <img src="${!imageData.Url ? imageFallback : imageData.Url}" />
                    </div>
                </div>
                <div class="${resourceContent}">
                    ${featuredLabel}
                    <div class="${resourceType}">${contentType.Title}</div>`;
        if (contentType.Id === '95d3ec8e-65be-4005-bbbf-cf94764bec84' && StartDate) {
            const startDate = new Date(StartDate);
            html += `<div class="${webinarStartDate}">${startDate.getDate()} ${this.getMonthName(startDate.getMonth(), this.filterService.getSelectedLanguage())}</div>`
        }

        html += `<h2 class="h4">${this.encodeHtml(Title)}</h2>`;

        if (Summary) {
            html += `<div class="${resourceSummary}">${this.encodeHtml(Summary)}</div>`
        }

        html += `
                </div>
                `;

        if (CTAText) {
            html += `<div class="${resourceCTA}"><span>${this.encodeHtml(CTAText)}</span></div>`
        }

        html += `
            </a>
        </div>
    `;

        return html;
    }

    getMonthName(monthNumber, language) {
        const monthNameArray = this.monthNamesMap.get(language);
        return monthNameArray[monthNumber];
    }
}
